'use client'

import { Chip } from '../chip/chip.tsx'
import { Tooltip } from '../tooltip/tooltip.tsx'
import { useMultiselectContext } from './use-multiselect.ts'

type MultiselectPlusMoreProps = {
  count: number
  offset?: number
  tooltip?: string
}

const MultiselectPlusMore = ({
  count,
  offset,
  tooltip,
}: MultiselectPlusMoreProps) => {
  const { getPlusMoreText } = useMultiselectContext()

  return (
    <div className="absolute top-0" style={{ left: offset }}>
      {tooltip ? (
        <Tooltip content={tooltip}>
          <Chip>{getPlusMoreText(count)}</Chip>
        </Tooltip>
      ) : (
        <Chip>{getPlusMoreText(count)}</Chip>
      )}
    </div>
  )
}

export { MultiselectPlusMore }
